import DOMPurify from 'dompurify';
import get from 'lodash/get';

export const normalizePreviewText = text => (typeof text === 'string' ? text : '').replace(/\s+/g, ' ').trim();

export function buildMessagePreview(content, attachments = []) {
  const template = document.createElement('template');
  template.innerHTML = DOMPurify.sanitize(typeof content === 'string' ? content : '');
  template.content.querySelectorAll('script, style, template, noscript').forEach(element => element.remove());
  const images = template.content.querySelectorAll('img');
  let imageCount = images.length;
  let fileCount = 0;

  // Keep the words surrounding an inline image in order, without its thumbnail.
  images.forEach(image => image.replaceWith(' '));
  template.content.querySelectorAll('br').forEach(lineBreak => lineBreak.replaceWith(' '));
  template.content.querySelectorAll('p, div, h1, h2, h3, h4, h5, h6, li, blockquote, pre, td, th')
    .forEach(block => {
      block.prepend(' ');
      block.append(' ');
    });

  (attachments || []).filter(Boolean).forEach(attachment => {
    const asset = get(attachment, 'asset.file.payload');
    const file = asset || get(attachment, 'file') || {};
    const mime = String(file.mime || file.mime_type || get(attachment, 'url.type', '')).toLowerCase();
    // Legacy attachments lack MIME metadata; infer images from the URL path only.
    const path = String(file.url || '').split(/[?#]/)[0];
    const isImage = mime.startsWith('image/')
      || (!mime && /\.(avif|bmp|gif|ico|jpe?g|png|svg|tiff?|webp)$/i.test(path));
    if (isImage) imageCount += 1;
    else fileCount += 1;
  });

  return {
    content: normalizePreviewText(template.content.textContent),
    attachmentCount: imageCount + fileCount,
    attachmentIcon: imageCount && fileCount ? 'paperclip' : imageCount ? 'image' : 'file-lines',
  };
}

export function selectedCarouselAgentName(reply = {}) {
  const displayName = normalizePreviewText(get(reply, 'display_name'));
  const fullName = [normalizePreviewText(get(reply, 'first_name')), normalizePreviewText(get(reply, 'last_name'))].filter(Boolean).join(' ');
  const legacyName = normalizePreviewText(get(reply, 'content')).replace(/^Select\s+/i, '');
  return displayName || fullName || legacyName || 'No name provided';
}
